export default function CompanySection() {
  const companyInfo = [
    { label: '社名', value: '合同会社Naturi' },
    { label: '代表社員', value: '櫻澤賢悟' },
    {
      label: '所在地',
      value: '東京都港区北青山一丁目3番1号 アールキューブ青山3階',
    },
    {
      label: '事業内容',
      value: [
        '教育訓練事業及び教育に関する研修、立案',
        'DX戦略設計/実行支援',
        'ECモール/SNS運用支援',
        '採用/広報支援(SNS活用)',
        'e-learning研修',
      ],
    },
  ];

  return (
    <section id="company" className="py-16 sm:py-24 md:py-32 bg-[#f8f9fa]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-8 sm:mb-10 md:mb-14">
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#333333] mb-4 tracking-wide">会社概要</h2>
        </div>

        <div className="max-w-4xl mx-auto space-y-6 sm:space-y-8">
          <div className="bg-white border border-gray-200 p-4 sm:p-5 md:p-7 lg:p-8 space-y-3 rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.08)]">
            {companyInfo.map((info, index) => (
              <div key={index}>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-1.5 sm:gap-3">
                  <div className="text-[0.8rem] sm:text-sm md:text-base text-[#333333] font-normal">{info.label}</div>
                  <div className="sm:col-span-2 text-[0.8rem] sm:text-sm md:text-base text-[#333333] leading-[1.7]">
                    {Array.isArray(info.value) ? (
                      <ul className="space-y-0.5">
                        {info.value.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    ) : (
                      <span>{info.value}</span>
                    )}
                  </div>
                </div>
                {index < companyInfo.length - 1 && <div className="w-full h-px bg-gray-300 mt-3"></div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
